import { render } from "./RcpBasicDetails.vue?vue&type=template&id=5a6cd0c2&scoped=true"
import script from "./RcpBasicDetails.vue?vue&type=script&lang=js"
export * from "./RcpBasicDetails.vue?vue&type=script&lang=js"

import "./RcpBasicDetails.vue?vue&type=style&index=0&id=5a6cd0c2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a6cd0c2"]])

export default __exports__